import { createActions, createReducer } from "reduxsauce";
import { call, put, all, takeEvery, take, delay } from "redux-saga/effects";
import { axiosCall } from "../helpers/funtioncs";
import { Creators as creatorsConfig } from "../ducks/config";

const apiPetcozoo_baseUrl = process.env.REACT_APP_API_PETCOZOO;

/* --------Sagas-----------*/
function* getAllStoresSaga({ token }) {
  try {
    const allStores = yield call(axiosCall, {
      method: "get",
      url: `${apiPetcozoo_baseUrl}/stores/getAllStores`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    yield put(Creators.getStoresSuccess(allStores.data));
  } catch (error) {
    console.error("Error fetching Stores:", error);
    yield put(Creators.fail());
  }
}

function* getIDStoresSaga({ token }) {
  try {
    const IDStores = yield call(axiosCall, {
      method: "get",
      url: `${apiPetcozoo_baseUrl}/stores/getIDStores`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    yield put(Creators.getStoresSuccess(IDStores.data));
  } catch (error) {
    console.error("Error fetching Stores:", error);
    yield put(Creators.fail());
  }
}
function* getInfoStoresSaga({ token, storeId }) {
  try {
    const response = yield call(axiosCall, {
      method: "get",
      url: `${apiPetcozoo_baseUrl}/stores/getInfoStore/${storeId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    //console.log(response.data);
    yield put(Creators.getInfoStoresSuccess(response.data));
  } catch (error) {
    console.error("Error fetching Stores:", error);
    yield put(Creators.fail());
  }
}

function* updateStockStoresSaga({ token, storeId, newStock }) {
  try {
    const store = yield call(axiosCall, {
      method: "put",
      url: `${apiPetcozoo_baseUrl}/stores/updateStock/${storeId}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: {
        newStock: newStock,
      },
    });
    //console.log(newStock);
    yield all([
      yield put(Creators.updateStockSuccess([store.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Inventario actualizado`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    //console.log(error);
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    yield all([
      yield put(Creators.fail()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* updateStoreByIdSaga({ token, storeId, inventory }) {
  try {
    const store = yield call(axiosCall, {
      method: "put",
      url: `${apiPetcozoo_baseUrl}/stores/updateStoreById/${storeId}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: {
        inventory: inventory,
      },
    });
    //console.log(inventory);
    yield all([
      yield put(Creators.updateStockSuccess([store.data.data])),
      yield put(
        creatorsConfig.message({
          text: `Inventario actualizado`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    //console.log(error);
    const message =
      error.response !== null ? error.response.data.error : "Ocurrio un error";
    yield all([
      yield put(Creators.fail()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* getStoreByIdSaga({ token, idUser }) {
  try {
    const store = yield call(axiosCall, {
      method: "get",
      url: `${apiPetcozoo_baseUrl}/stores/getStoreById/${idUser}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    yield put(Creators.getStoresSuccess([store.data]));
  } catch (error) {
    console.error("Error fetching Stores:", error);
    yield put(Creators.fail());
  }
}
function* getInventoryClusterByStoreSaga({ token, storeId }) {
  try {
    const inventoryCluster = yield call(axiosCall, {
      method: "get",
      url: `${apiPetcozoo_baseUrl}/stores/getInventoryClusterByStore/${storeId}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    const { inventoryStore, signal } = inventoryCluster.data;

    yield put(Creators.getInventoryClusterSuccess(inventoryStore, signal));
  } catch (error) {
    console.error("Error fetching Inventory Cluster:", error);
    yield put(Creators.fail());
  }
}
function* updateInventoryOrderSaga({ token, storeId, updates }) {
  try {
    const result = yield call(axiosCall, {
      method: "put",
      url: `${apiPetcozoo_baseUrl}/stores/updateInventoryOrder/${storeId}`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: updates,
    });

    yield all([
      put(Creators.updateInventoryOrderSuccess()),
      put(
        creatorsConfig.message({
          text: `Inventario actualizado`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    console.error("Error actualizando Order:", error);
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";

    yield all([
      put(Creators.fail()),
      put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* downloadInventorySaga({ token, week }) {
  try {
    //console.log(week);
    const urlDownload = week
      ? `${apiPetcozoo_baseUrl}/stores/downloadInventoryCSV/${week}`
      : `${apiPetcozoo_baseUrl}/stores/downloadInventoryCSV`;

    const downloadResponse = yield call(axiosCall, {
      method: "get",
      url: urlDownload,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      responseType: "blob",
    });

    const blob = new Blob([downloadResponse.data], { type: "text/csv" });
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${day}-${month}-${year}`;
    const fileName = `InventarioTienda_${formattedDate}.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute("download", fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    yield all([
      yield put(Creators.downloadInventoryStoreSuccess()),
      yield put(
        creatorsConfig.message({
          text: `Se descargó inventario tiendas`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    yield all([
      yield put(Creators.fail()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* downloadInventoryByStoreSaga({ token, storeId }) {
  try {
    const urlDownload = `${apiPetcozoo_baseUrl}/stores/downloadInventoryCSVbyStore/${storeId}`;

    const downloadResponse = yield call(axiosCall, {
      method: "get",
      url: urlDownload,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      responseType: "blob",
    });

    const blob = new Blob([downloadResponse.data], { type: "text/csv" });
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${day}-${month}-${year}`;
    const fileName = `InventarioTienda_${storeId}_${formattedDate}.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute("download", fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    yield all([
      yield put(Creators.downloadInventoryStoreSuccess()),
      yield put(
        creatorsConfig.message({
          text: `Se descargó inventario tiendas`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    yield all([
      yield put(Creators.fail()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}
function* downloadInventoryClusterByStoreSaga({ token, storeId }) {
  try {
    const urlDownload = `${apiPetcozoo_baseUrl}/stores/downloadInventoryClusterByStore/${storeId}`;

    const downloadResponse = yield call(axiosCall, {
      method: "get",
      url: urlDownload,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      responseType: "blob",
    });

    const blob = new Blob([downloadResponse.data], { type: "text/csv" });
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${day}-${month}-${year}`;
    const fileName = `InventarioCluster_${storeId}_${formattedDate}.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute("download", fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    yield all([
      put(Creators.downloadInventoryStoreSuccess()),
      put(
        creatorsConfig.message({
          text: `Se descargó inventario clúster`,
          type: "success",
        })
      ),
    ]);
  } catch (error) {
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrió un error";
    yield all([
      put(Creators.fail()),
      put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* downloadCSVOrderGlobalSaga({ token }) {
  try {
    const urlDownload = `${apiPetcozoo_baseUrl}/stores/downloadCSVOrderGlobal`;

    const downloadResponse = yield call(axiosCall, {
      method: "get",
      url: urlDownload,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });

    let isFileReady = false;
    while (!isFileReady) {
      yield delay(10000); // Esperar 10 segundos antes de volver a intentar
      const checkResponse = yield call(axiosCall, {
        method: "get",
        url: `${apiPetcozoo_baseUrl}/stores/downloadCSVOrderGlobalAsync/${downloadResponse.data.uuid}`,
        headers: { authorization: token },
        responseType: "blob",
      });
      if (checkResponse.status === 200) {
        const blob = new Blob([checkResponse.data], { type: "text/csv" });
        const currentDate = new Date();
        const formattedDate = currentDate
          .toLocaleDateString()
          .split("/")
          .join("-");
        const fileName = `OrdenesTiendas${formattedDate}.csv`;
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute("download", fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        isFileReady = true;
        yield all([
          put(Creators.downloadCSVOrderGlobalSuccess()),
          put(
            creatorsConfig.message({
              text: "Se descargaron las órdenes globales",
              type: "success",
            })
          ),
        ]);
      }
    }
  } catch (error) {
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrió un error al descargar las órdenes globales";
    yield all([
      put(Creators.fail()),
      put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

export default function* Stores() {
  yield all([
    takeEvery(Types.GET_ALL_STORES, getAllStoresSaga),
    takeEvery(Types.GET_ID_STORES, getIDStoresSaga),
    takeEvery(Types.GET_STORE_BY_ID, getStoreByIdSaga),
    takeEvery(Types.GET_INFO_STORES, getInfoStoresSaga),
    takeEvery(Types.UPDATE_STOCK_STORES, updateStockStoresSaga),
    takeEvery(Types.UPDATE_STORE_BY_ID, updateStoreByIdSaga),
    takeEvery(Types.DOWNLOAD_INVENTORY, downloadInventorySaga),
    takeEvery(Types.DOWNLOAD_INVENTORY_BY_STORE, downloadInventoryByStoreSaga),

    takeEvery(
      Types.GET_INVENTORY_CLUSTER_BY_STORE,
      getInventoryClusterByStoreSaga
    ),
    takeEvery(
      Types.DOWNLOAD_INVENTORY_CLUSTER_BY_STORE,
      downloadInventoryClusterByStoreSaga
    ),
    takeEvery(Types.DOWNLOAD_CSV_ORDER_GLOBAL, downloadCSVOrderGlobalSaga),
    takeEvery(Types.UPDATE_INVENTORY_ORDER, updateInventoryOrderSaga),
  ]);
}

/*-----------Action types & creators-------------*/
export const { Types, Creators } = createActions({
  getAllStores: ["token"],
  getIDStores: ["token"],
  getStoreById: ["token", "idUser"],
  getInfoStores: ["token", "storeId"],
  getStoresSuccess: ["stores"],
  getInfoStoresSuccess: ["storesInfo"],
  updateStockStores: ["token", "storeId", "newStock"],
  updateStoreById: ["token", "storeId", "inventory"],
  updateStockSuccess: ["newStock"],
  downloadInventory: ["token", "week"],
  downloadInventoryByStore: ["token", "storeId"],
  downloadInventoryStoreSuccess: null,
  getInventoryClusterByStore: ["token", "storeId"],
  updateInventoryOrder: ["token", "storeId", "updates"],
  updateInventoryOrderSuccess: ["updates"],
  getInventoryClusterSuccess: ["inventoryCluster", "signal"],
  downloadInventoryClusterByStore: ["token", "storeId"],
  downloadCSVOrderGlobal: ["token"],
  downloadCSVOrderGlobalSuccess: null,
  clearAllStores: null,
  fail: null,
});

/*------------Reducers-----------*/
const INITIAL_STATE = {
  stores: [],
  loading: false,
};

const getAllStores = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const getInfoStores = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});
const getIDStores = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const getStoreById = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const getStoresSuccess = (state = INITIAL_STATE, { stores }) => {
  return {
    ...state,
    loading: false,
    stores: stores,
  };
};
const getInfoStoresSuccess = (state = INITIAL_STATE, { storesInfo }) => {
  return {
    ...state,
    loading: false,
    storesInfo: storesInfo,
  };
};

const getInventoryClusterByStore = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const updateInventoryOrder = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const getInventoryClusterSuccess = (
  state = INITIAL_STATE,
  { inventoryCluster, signal }
) => ({
  ...state,
  loading: false,
  inventoryCluster: inventoryCluster,
  signal: signal,
});

const updateStockStores = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const updateStoreById = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const updateStockSuccess = (state = INITIAL_STATE, { newStock }) => {
  return {
    ...state,
    loading: false,
    stores: newStock,
  };
};

const updateInventoryOrderSuccess = (state = INITIAL_STATE, { updates }) => {
  return {
    ...state,
    loading: false,
    updates: updates,
  };
};

const downloadInventory = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const downloadInventoryByStore = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});
const downloadInventoryClusterByStore = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const downloadInventoryStoreSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});

const downloadCSVOrderGlobal = (state = INITIAL_STATE) => {
  return {
    ...state,
    loadingGlobal: true,
  };
};
const downloadCSVOrderGlobalSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loadingGlobal: false,
});
const clearAllStores = (state = INITIAL_STATE) => ({
  ...state,
  stores: [],
  loading: false,
});

const fail = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
});

const HANDLERS = {
  [Types.GET_ALL_STORES]: getAllStores,
  [Types.GET_INFO_STORES]: getInfoStores,
  [Types.GET_ID_STORES]: getIDStores,
  [Types.GET_STORE_BY_ID]: getStoreById,
  [Types.UPDATE_STOCK_STORES]: updateStockStores,
  [Types.UPDATE_STORE_BY_ID]: updateStoreById,
  [Types.UPDATE_STOCK_SUCCESS]: updateStockSuccess,
  [Types.GET_STORES_SUCCESS]: getStoresSuccess,
  [Types.GET_INFO_STORES_SUCCESS]: getInfoStoresSuccess,
  [Types.DOWNLOAD_INVENTORY]: downloadInventory,
  [Types.DOWNLOAD_INVENTORY_BY_STORE]: downloadInventoryByStore,
  [Types.DOWNLOAD_INVENTORY_STORE_SUCCESS]: downloadInventoryStoreSuccess,
  [Types.GET_INVENTORY_CLUSTER_BY_STORE]: getInventoryClusterByStore,
  [Types.UPDATE_INVENTORY_ORDER]: updateInventoryOrder,
  [Types.UPDATE_INVENTORY_ORDER_SUCCESS]: updateInventoryOrderSuccess,
  [Types.GET_INVENTORY_CLUSTER_SUCCESS]: getInventoryClusterSuccess,
  [Types.DOWNLOAD_CSV_ORDER_GLOBAL]: downloadCSVOrderGlobal,
  [Types.DOWNLOAD_INVENTORY_CLUSTER_BY_STORE]: downloadInventoryClusterByStore,
  [Types.DOWNLOAD_CSV_ORDER_GLOBAL_SUCCESS]: downloadCSVOrderGlobalSuccess,
  [Types.CLEAR_ALL_STORES]: clearAllStores,
  [Types.FAIL]: fail,
};

export const reducersStores = createReducer(INITIAL_STATE, HANDLERS);
